// extracted by mini-css-extract-plugin
export const input = "form-input-module--input--3uuTa";
export const dark = "form-input-module--dark--2z4Fr";
export const errors = "form-input-module--errors--DXpQ5";